// extracted by mini-css-extract-plugin
export default {"root":"ImageWithParticles-module__root","logo":"ImageWithParticles-module__logo","particles":"ImageWithParticles-module__particles","logoImg":"ImageWithParticles-module__logoImg"};